import HeaderBusinessVariantDefault from './HeaderBusinessVariantDefault.component';
export default HeaderBusinessVariantDefault;